import Vue from 'vue';
import api from './api';
import dialog from './dialog-helper';

Vue.use(api);
Vue.use(dialog);
